/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlannedUnitCostRequest } from '../../models/create-planned-unit-cost-request';
import { PlannedUnitCostDto } from '../../models/planned-unit-cost-dto';

export interface CreatePlannedUnitCost$Params {
      body: CreatePlannedUnitCostRequest
}

export function createPlannedUnitCost(http: HttpClient, rootUrl: string, params: CreatePlannedUnitCost$Params, context?: HttpContext): Observable<StrictHttpResponse<PlannedUnitCostDto>> {
  const rb = new RequestBuilder(rootUrl, createPlannedUnitCost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlannedUnitCostDto>;
    })
  );
}

createPlannedUnitCost.PATH = '/v0/plannedUnitCosts/{id}';
